import {StoreProvider} from 'lowkey-component';

import {
  IApplicationState,
  MediaQueryScreenMode,
  OneViewStatus,
  Orientation,
} from '@services/types';
import {
  isOpenGlobalNavSaved,
  isScrollStopSaved,
  mediaQueryScreenModeSaved,
  oneViewStatusSaved,
  orientationSaved,
  pageIndicatorStatusSaved,
  siteIndicatorPercentSaved,
  siteIndicatorStatusSaved,
  videoIsFullscreenSaved,
} from '@store/appSlice';

export const createApplicationState = (): IApplicationState => {
  const store = StoreProvider.create();
  return {
    updateIsOpenGlobalNav: (isOpen: boolean) => {
      store.dispatch(isOpenGlobalNavSaved(isOpen));
    },
    updateMediaQueryScreenMode: (mode: MediaQueryScreenMode) => {
      store.dispatch(mediaQueryScreenModeSaved(mode));
    },
    updateOrientation(orientation: Orientation) {
      store.dispatch(orientationSaved(orientation));
    },
    updatePageIndicatorStatus(status) {
      store.dispatch(pageIndicatorStatusSaved(status));
    },
    updateSiteIndicatorPercent(percent: number) {
      store.dispatch(siteIndicatorPercentSaved(percent));
    },
    updateSiteIndicatorStatus(status) {
      store.dispatch(siteIndicatorStatusSaved(status));
    },
    updateOneViewStatus: (status: OneViewStatus) => {
      store.dispatch(oneViewStatusSaved(status));
    },
    updateScrollStatus: (isStop: boolean) => {
      store.dispatch(isScrollStopSaved(isStop));
    },
    updateVideoIsFullScreen: (isFullscreen: boolean) => {
      store.dispatch(videoIsFullscreenSaved(isFullscreen));
    },
  };
};
